/**
 * Logo upload preview for custom gear product forms.
 */
class OtakuforgeLogoUpload extends HTMLElement {
  connectedCallback() {
    this.#fileInput = this.querySelector('[data-logo-file]');
    this.#preview = this.querySelector('[data-preview]');
    this.#previewImg = this.querySelector('[data-preview-img]');
    this.#previewName = this.querySelector('[data-preview-name]');

    this.#fileInput?.addEventListener('change', this.#onFileChange);
  }

  disconnectedCallback() {
    this.#fileInput?.removeEventListener('change', this.#onFileChange);
    if (this.#objectUrl) {
      URL.revokeObjectURL(this.#objectUrl);
    }
  }

  /** @type {HTMLInputElement | null} */
  #fileInput = null;
  /** @type {HTMLElement | null} */
  #preview = null;
  /** @type {HTMLImageElement | null} */
  #previewImg = null;
  /** @type {HTMLElement | null} */
  #previewName = null;
  /** @type {string | undefined} */
  #objectUrl;

  #onFileChange = () => {
    const file = this.#fileInput?.files?.[0];
    if (!this.#preview || !this.#previewImg || !this.#previewName) return;

    if (this.#objectUrl) {
      URL.revokeObjectURL(this.#objectUrl);
      this.#objectUrl = undefined;
    }

    if (!file) {
      this.#preview.hidden = true;
      return;
    }

    this.#previewName.textContent = file.name;
    this.#objectUrl = URL.createObjectURL(file);
    this.#previewImg.src = this.#objectUrl;
    this.#preview.hidden = false;
  };
}

if (!customElements.get('otakuforge-logo-upload')) {
  customElements.define('otakuforge-logo-upload', OtakuforgeLogoUpload);
}
